import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import Text from 'components/Text/Text';
import ChunkOfTextWithCopying from 'components/Text/ChunkOfTextWithCopying';
import style from './DownloadAppIosUrlField.module.scss';

const DownloadAppIosUrlField: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="downloadAppIosUrlLabel" theme="neutralLight" size="xs" />
			<div className={style.contentWrapper}>
				{restaurantForFullInfo?.downloadAppIosUrl ? (
					<>
						<Text
							translationKey={restaurantForFullInfo.downloadAppIosUrl || ''}
							size="s"
							withTooltip={true}
						/>
						<ChunkOfTextWithCopying
							text={restaurantForFullInfo.downloadAppIosUrl || ''}
							className={style.externalId}
						/>
					</>
				) : (
					'-'
				)}
			</div>
		</div>
	);
};

export default DownloadAppIosUrlField;
